
const app = {
    state:{
        currentRoute: '',
        moduleIndex: 0,
        userInfo: ""
       
    },
    mutations: {
        setCurrentRoute(state,route){
            console.log(route);
            state.currentRoute = route;
        },
        setModuleIndex(state,index){
            state.moduleIndex = index;
        },
        setUserInfo(state,data){
            state.userInfo = data;
        }
        
    },
    actions:{
      
    }
}

export default app;